import { render, staticRenderFns } from "./EditAssignment.vue?vue&type=template&id=5c93e182&scoped=true&"
import script from "./EditAssignment.vue?vue&type=script&lang=js&"
export * from "./EditAssignment.vue?vue&type=script&lang=js&"
import style0 from "./EditAssignment.vue?vue&type=style&index=0&id=5c93e182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c93e182",
  null
  
)

export default component.exports